import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manning-agency-app-posts-details',
  templateUrl: './manning-agency-app-posts-details.component.html',
  styleUrls: ['./manning-agency-app-posts-details.component.css']
})
export class ManningAgencyAppPostsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
